<span class="clear-input search-rules">
  @if (scopeFolder) {
    <i [ngClass]="scopeFolder.outlinedIcon ? 'material-icons-outlined' : 'material-icons'"
       class="notranslate scope-icon"
       role="img"
       [attr.aria-label]="scopeTooltip"
       [matTooltip]="scopeTooltip"
       [matTooltipShowDelay]="500"
       matTooltipPosition="above">{{ scopeFolder.icon }}</i>
  }
  <input
    type="text"
    class="search-profiles"
    [value]="value"
    (keyup)="onKeyup($event)"
    (keydown.escape)="clearInput(searchInput)"
    [placeholder]="activePlaceholder"
    #searchInput
  />
  <i class="material-icons notranslate clear-icon"
     [class.has-value]="searchInput.value"
     (click)="clearInput(searchInput)"
     (keydown.enter)="clearInput(searchInput)"
     (keydown.space)="$event.preventDefault(); clearInput(searchInput)"
     [attr.role]="searchInput.value ? 'button' : null"
     [attr.aria-label]="searchInput.value ? 'Clear search' : null"
     [attr.tabindex]="searchInput.value ? '0' : '-1'"
     [matTooltip]="searchInput.value ? 'Clear search' : ''"
     [matTooltipShowDelay]="500"
     matTooltipPosition="above">{{ searchInput.value ? 'close' : 'search' }}</i>
</span>
